export default "__VITE_ASSET__4qEXjmaA__"